import {lazySrcRequiredAttribute, loadImage} from "../../elements/img.lazy-image";

const loadRequiredImages = ( header ) => {
	header?.querySelectorAll( `img[${lazySrcRequiredAttribute}]` )
		.forEach( ( img ) => {
			loadImage( img );
			
			img.removeAttribute( lazySrcRequiredAttribute );
		} );
};

export const initHeader = () => {
	const header = document.querySelector( `body > header` );

	if ( !header )
	{
		return;
	}

	if ( document.querySelector( 'body > nav' ) )
	{
		document.body.classList.add( 'with-submenu' );
	}

	const headerInput = document.querySelector( 'input#supermenu' );
	let currentScroll = 0, rememberScroll, scrollTimeout;
	
	if ( headerInput && headerInput.cheched )
	{
		loadRequiredImages( header );
	}
	
	const pauseTransition = () => {
		clearTimeout( scrollTimeout );
		header.classList.remove( 'transition' );

		scrollTimeout = setTimeout( () => {
			header.classList.add( 'transition' );
		}, 400 );
	}

	headerInput.addEventListener( 'change', ( evt ) => {
		loadRequiredImages( header );
		
		if ( evt.target.checked )
		{
			document.body.style.position = 'fixed';
			document.body.style.top = currentScroll * -1 + 'px';
			document.body.style.left = 0;
			document.body.style.overflow = 'hidden';
			document.body.style.width = '100%';
			rememberScroll = currentScroll;
		}
		else
		{
			document.body.removeAttribute( 'style' );
			window.scrollTo( 0, rememberScroll );
		}
	} );

	window.addEventListener( `scroll`, () => {
		if ( document.body.classList.contains( 'with-submenu' ) )
		{
			if ( currentScroll < window.pageYOffset )
			{
				header.classList.add( 'scroll-down' );
			}
			else
			{
				header.classList.remove( 'scroll-down' );
			}
		}
			
		currentScroll = window.pageYOffset;
		
		if ( window.pageYOffset >= header.offsetHeight )
		{
			header.classList.add( `fixed` );
			pauseTransition();
		}

		if ( window.pageYOffset >= window.innerHeight )
		{
			header.classList.add( `show` );
		}

		if ( window.pageYOffset <= 0 && !headerInput.checked )
		{
			header.classList.remove( `show` );
			header.classList.remove( `fixed` );
			pauseTransition();
		}
	} );

	header.querySelector( 'div.container > label' ).addEventListener( 'mouseenter', () => {
		header.classList.remove( 'transition' );
	} );

	header.querySelector( 'div.container > label' ).addEventListener( 'mouseleave', () => {
		header.classList.add( 'transition' );
	} );
};
